
import {FTYPES} from 'consts/ftypes.js'

export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    primary: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'upload-02'
    },
    stroke: {
      type: String,
      default: 'var(--gray-700)'
    },
    accept: {
      type: String,
      default: FTYPES['document'].exts.join(',')
    },
    loading: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['upload'],
  data() {
    return {
      input_id: crypto.randomUUID()
    }
  },
  computed: {
    loader_color(){
      if (this.primary)
        return 'var(--base-white)'
      return undefined
    }
  },
  watch: {
    loading(val) {
      if (val) 
        this.$refs.button.$el.blur()
    },
  }
}
